/**
 * Tab-scoped session management for HIPAA-compliant per-tab isolation.
 *
 * The token lives in `sessionStorage` which is scoped to the browser tab.
 * Opening a new window or tab starts with an empty sessionStorage so the
 * new context has no token → the user must log in again.  Page refreshes
 * within the same tab preserve sessionStorage, so the session survives.
 */

const TAB_SESSION_KEY = "tab_session_token";

export function getTabSessionToken(): string | null {
  try {
    return sessionStorage.getItem(TAB_SESSION_KEY);
  } catch {
    return null;
  }
}

export function setTabSessionToken(token: string): void {
  try {
    sessionStorage.setItem(TAB_SESSION_KEY, token);
  } catch {
    /* storage full or unavailable */
  }
}

export function clearTabSessionToken(): void {
  try {
    sessionStorage.removeItem(TAB_SESSION_KEY);
  } catch {
    /* ignore */
  }
}

export function hasTabSession(): boolean {
  return !!getTabSessionToken();
}
